import { Navigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";
import SlideshowTab from "@/components/dashboard/SlideshowTab";
import ProgramTab from "@/components/dashboard/ProgramTab";
import PengurusTab from "@/components/dashboard/PengurusTab";
import ProfilTab from "@/components/dashboard/ProfilTab";
import ArtikelTab from "@/components/dashboard/ArtikelTab";
import AlumniTab from "@/components/dashboard/AlumniTab";
import KontributorTab from "@/components/dashboard/KontributorTab";
import KelolaAkunTab from "@/components/dashboard/KelolaAkunTab";
import PersetujuanTab from "@/components/dashboard/PersetujuanTab";
import GalangDanaTab from "@/components/dashboard/GalangDanaTab";
import BannerTab from "@/components/dashboard/BannerTab";
import PpdbTab from "@/components/dashboard/PpdbTab";
import AkunTab from "@/components/dashboard/AkunTab";

export default function DashboardPage() {
  const { user } = useAuth();
  const { t } = useLang();

  if (user === undefined) {
    return <div className="max-w-7xl mx-auto px-6 py-24 text-slate-500">{t("common.loading")}</div>;
  }
  if (!user) return <Navigate to="/masuk" replace />;

  const tabs =
    user.role === "admin"
      ? ["persetujuan", "slideshow", "banner", "program", "galang", "ppdb", "pengurus", "profil", "artikel", "alumni", "kontributor", "kelola_akun"]
      : user.role === "kontributor"
      ? ["artikel", "akun"]
      : ["akun"];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="dashboard-page">
      <div className="flex flex-wrap items-center gap-3 mb-8">
        <h1 className="font-display text-4xl font-bold text-emerald-950 tracking-tight">{t("dash.title")}</h1>
        <Badge className="bg-[#D4AF37]/20 text-emerald-950 border border-[#D4AF37] hover:bg-[#D4AF37]/20" data-testid="dashboard-role-badge">
          {t(`dash.role.${user.role}`)}
        </Badge>
      </div>

      <Tabs defaultValue={tabs[0]}>
        <TabsList className="flex flex-wrap h-auto gap-1 mb-8">
          {tabs.map((tab) => (
            <TabsTrigger key={tab} value={tab} data-testid={`dash-tab-${tab}`}>
              {t(`dash.${tab}`)}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.includes("persetujuan") && <TabsContent value="persetujuan"><PersetujuanTab /></TabsContent>}
        {tabs.includes("slideshow") && <TabsContent value="slideshow"><SlideshowTab /></TabsContent>}
        {tabs.includes("banner") && <TabsContent value="banner"><BannerTab /></TabsContent>}
        {tabs.includes("galang") && <TabsContent value="galang"><GalangDanaTab /></TabsContent>}
        {tabs.includes("ppdb") && <TabsContent value="ppdb"><PpdbTab /></TabsContent>}
        {tabs.includes("program") && <TabsContent value="program"><ProgramTab /></TabsContent>}
        {tabs.includes("pengurus") && <TabsContent value="pengurus"><PengurusTab /></TabsContent>}
        {tabs.includes("profil") && <TabsContent value="profil"><ProfilTab /></TabsContent>}
        {tabs.includes("artikel") && <TabsContent value="artikel"><ArtikelTab user={user} /></TabsContent>}
        {tabs.includes("alumni") && <TabsContent value="alumni"><AlumniTab /></TabsContent>}
        {tabs.includes("kontributor") && <TabsContent value="kontributor"><KontributorTab /></TabsContent>}
        {tabs.includes("kelola_akun") && <TabsContent value="kelola_akun"><KelolaAkunTab /></TabsContent>}
        {tabs.includes("akun") && <TabsContent value="akun"><AkunTab user={user} /></TabsContent>}
      </Tabs>
    </div>
  );
}
